import { render, staticRenderFns } from "./MailSubject.vue?vue&type=template&id=38493eb8"
import script from "./MailSubject.vue?vue&type=script&lang=js"
export * from "./MailSubject.vue?vue&type=script&lang=js"
import style0 from "./MailSubject.vue?vue&type=style&index=0&id=38493eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports